import '../styles/App.css';

import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const StyledInput = styled(Input)({
  width: 42,
  verticalAlign: 'baseline',
  border: 0,
  outline: 0,
  padding: '0!important',
  color: '#fff',
  borderBottom: `1px solid rgba(255, 255, 255, 0.2)`,
  '&:after': {
    borderBottom: `0px solid #00C4ED`
  }
});

const CustomSlider = styled(Slider)({
  '& .MuiSlider-rail': {
    backgroundImage: "linear-gradient(.25turn, #00C4ED, #00E880)",
    height: 3, // Thinner rail
  },
  '& .MuiSlider-track': {
    backgroundImage: "linear-gradient(.25turn, #00C4ED, #00E880)",
    height: 3, // Thinner track
  },
  '& .MuiSlider-thumb': {
    backgroundImage: "linear-gradient(.25turn, #00C4ED, #00E880)",
    width: 16, // Smaller thumb
    height: 16, // Smaller thumb
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(0, 196, 237, 0.16)',
    },
  }
});

export default function InputSlider(props) {
  const min = props.values[0]
  const max = props.values[props.values.length-1]

  const [value, setValue] = React.useState(props.startValue);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
    // props.handleClick(newValue, props.name)
  }

  const handleSliderCommittedChange = (event, newValue) => {
    setValue(newValue);
    props.handleClick(newValue, props.name)
  }

  // const handleInputChange = (event) => {
  //   setValue(event.target.value === '' ? '' : Number(event.target.value));
  //   props.handleClick(event.target.value, props.name)
  // }

  const [inputTimeout, setInputTimeout] = React.useState(null);

  const handleInputChange = (event) => {
    let newValue = event.target.value === '' ? '' : Number(event.target.value);

    // Clear the previous timeout
    if (inputTimeout) {
      clearTimeout(inputTimeout);
    }

    setValue(newValue);

    // Delay validation and update by 500ms
    const timeout = setTimeout(() => {
      if (newValue !== '') {
        if (newValue < min) {
          newValue = min;
        } else if (newValue > max) {
          newValue = max;
        }
      }
      setValue(newValue);
      props.handleClick(newValue, props.name);
    }, 1000); // Adjust the delay time if needed

    setInputTimeout(timeout);
  };

  var dropdownOptions = []
  for (var i = 0; i < props.values.length; i++) {
    // this.gradient(percentage).toString()
    dropdownOptions.push(
      <MenuItem key={props.labels[i]} value={props.values[i]} >{props.labels[i]}</MenuItem>
    )
  }

  var useDropdown = props.labels.length != props.values.length ? false : true

  var input = useDropdown ? <FormControl sx={{ m: 1, width: 500, height: 500 }}>
          <Select
            style={{color: 'white', fontWeight: '300'}}
            value={value}
            onChange={handleInputChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
          >
          {dropdownOptions}
        </Select>
      </FormControl> 
        :
      <StyledInput
            value={value}
            margin="dense"
            onChange={handleInputChange}
            inputProps={{
              min: min,
              max: max,
              type: 'number',
              'aria-labelledby': 'input-slider',
              style: {
                padding: 0,
                fontFamily: 'Menco, Open Sans, sans-serif',
                fontWeight: 400
              }
            }}
          /> 

  const name = props.name.indexOf('?') !== -1 ? props.name : props.name + ':'

  return (
    <div className='form-item'>
        <div className='form-label'>{name}<span style={{paddingLeft: '16px', paddingRight: '5px'}}>{input}</span><span style={{fontFamily: 'Menco, Open Sans, sans-serif', fontWeight: 400, textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '12px'}}>{props.unit}</span></div>
          <CustomSlider
            className='form-item-slider'
            value={typeof value === 'number' ? value : 0}
            onChange={handleSliderChange}
            onChangeCommitted={handleSliderCommittedChange}
            aria-labelledby="input-slider"
            max={Number(max)}
            min={Number(min)}
          />
    </div>
  );
}